export function initSearch() {
    const searchBtnDesktop = document.querySelector('.kn_search-btn-desktop');
    const searchBtnMobile = document.querySelector('.kn_search-btn-mobile');
    const searchForm = document.querySelector('.kn_search-form');
    const searchClose = document.querySelector('.kn_search-form__close');
    const searchInput = document.querySelector('.kn_search-form__input');
    if (!searchBtnDesktop || !searchBtnMobile || !searchForm || !searchClose) return;

    // Öffnen der Suche
    searchBtnDesktop.addEventListener('click', (e) => {
        e.preventDefault();
        searchForm.classList.add('is-active');
        searchInput.focus();
        document.body.style.overflow = 'hidden';
    });

    searchBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        searchForm.classList.add('is-active');
        searchInput.focus();
        document.body.style.overflow = 'hidden';
    });

    // Schließen der Suche
    searchClose.addEventListener('click', () => {
        searchForm.classList.remove('is-active');
        searchInput.value = '';
        document.body.style.overflow = '';
    });

    // Schließen mit Escape-Taste
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchForm.classList.contains('is-active')) {
            searchForm.classList.remove('is-active');
            searchInput.value = '';
            document.body.style.overflow = '';
        }
    });
} 